import { useTranslation } from "react-i18next";
import { translate as tr } from "../../i18n";
import React from "react";
import ToggleButton from "./togglebutton";
import "../../assets/css/project-rate.css";

export default function ProjectBillingRateField({
  enabled,
  onToggle,
  rate,
  onRateChange,
  currencyLabel,
  currencyCode,
  workspaceRateLabel,
  error,
  warning,
  note,
  inputId = "project-hourly-rate",
  label = "Billing rate",
  title = "Override workspace default rate?",
}) {
  useTranslation();
  return (
    <div className="pm-field pm-field--wide">
      <label className="pm-label">{label}</label>
      <div className="pm-rate-card">
        <div className="pm-rate-row">
          <ToggleButton selected={enabled} toggleSelected={onToggle} ariaLabel={title} />
          <div className="pm-rate-copy">
            <div className="pm-rate-title">{title}</div>
            <div className="pm-rate-sub">
              {enabled
                ? tr("Enter a custom hourly rate for this project.")
                : workspaceRateLabel
                  ? <>{tr("Workspace default:")} <strong>{workspaceRateLabel}</strong></>
                  : tr("No workspace default rate is set yet.")}
            </div>
          </div>
        </div>

        {enabled ? (
          <div className="pm-rate-input-row">
            <span className="pm-rate-currency">
              {currencyCode || currencyLabel || tr("Workspace currency")}
            </span>
            <input
              id={inputId}
              className="pm-input pm-rate-input"
              type="number"
              min="0"
              step="1"
              placeholder="75"
              value={rate}
              onChange={(e) => onRateChange(e.target.value)}
            />
            <span className="pm-rate-suffix">{tr("/ hr")}</span>
          </div>
        ) : (
          <div className="pm-rate-preview">{tr("This project will use the workspace fallback until you turn the override on.")} </div>
        )}

        {warning && enabled && (
          <div className="pm-rate-warning">
            <strong>{tr("Important:")}</strong> {warning}
          </div>
        )}

        {note && <div className="pm-rate-note">{note}</div>}
        {error && <span className="pm-error">{error}</span>}
      </div>
    </div>
  );
}
